import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { inventoryDestinationFormSchema } from "../../schemas"

import { TRANSFER_FILTERABLE_STATUSES, TransferReason, TransferType } from "./constants"

import { SortingOrder, TransferSortField, TransferStatus } from "@/graphql/codegen/graphql"

export const transferLaunchFormSchema = z.object({
  type: z.nativeEnum(TransferType),
  sourceWarehouseAreaId: z.string().min(1, "Source Warehouse is required"),
})

export type TransferLaunchFormValues = z.infer<typeof transferLaunchFormSchema>

export const transferFormSchema = transferLaunchFormSchema.extend({
  reason: z.nativeEnum(TransferReason).optional(),
  comment: z.string().max(50, "Comment must not exceed 50 characters").optional(),
  documents: z.array(z.object({ file: z.instanceof(File) })).optional(),
})

export type TransferFormValues = z.infer<typeof transferFormSchema>

export const transferPalletSelectionFormSchema = z.object({
  destinations: z.array(inventoryDestinationFormSchema).min(1, "Select at least one pallet"),
})

export type TransferPalletSelectionFormValues = z.infer<typeof transferPalletSelectionFormSchema>

export const transferSearchSchema = z.object({
  query: z.string().optional(),
  field: fallback(z.nativeEnum(TransferSortField), TransferSortField.CreatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
  types: z.array(z.nativeEnum(TransferType)).optional(),
  statuses: z
    .array(z.nativeEnum(TransferStatus))
    .transform((statuses) => statuses.filter((status) => TRANSFER_FILTERABLE_STATUSES.includes(status)))
    .optional(),
  sourceWarehouseAreaIds: z.array(z.string()).optional(),
  targetWarehouseAreaIds: z.array(z.string()).optional(),
  createdByUserIds: z.array(z.string()).optional(),
  createdOnFrom: z.string().nullish(),
  createdOnTo: z.string().nullish(),
})

export type TransferSearchParams = z.infer<typeof transferSearchSchema>
